import axios from "axios";
import { get } from "lodash";

export default class Api {
  constructor(options = {}) {
    this.options = {
      skip_csrf: false,
      axios: {},
      ...options,
    };

    this.axios = axios.create({
      params: {
        _format: "json",
        lang_code: get(window, "vueBridge.langCode", "en"),
      },
      baseURL: "/see_learning/api",
      withCredentials: true,
      ...this.options.axios,
    });
  }

  async getCsrfToken(force = false) {
    if (this.options.skip_csrf) {
      return null;
    }

    if (this.token && !force) {
      return this.token;
    }

    const { data: token } = await axios.get("/session/token");

    return (this.token = token);
  }

  async get(endpoint, config = {}) {
    return await this.axios.get(endpoint, await this.configure(config));
  }

  async put(endpoint, data = {}, config = {}) {
    return await this.axios.put(endpoint, data, await this.configure(config));
  }

  async patch(endpoint, data = {}, config = {}) {
    return await this.axios.patch(endpoint, data, await this.configure(config));
  }

  async post(endpoint, data = {}, config = {}) {
    return await this.axios.post(endpoint, data, await this.configure(config));
  }

  async configure(config = {}) {
    return {
      ...config,
      headers: {
        "X-CSRF-Token": await this.getCsrfToken(),
      },
      // append timestmap to every request
      params: { ...(config.params || {}), t: Number(new Date()) },
    };
  }
}
